export class MarkdownUtils {
    static md: any = null;

    // TODO: resolve the real package, try npm installing instead of cdn in index.html
    // static md: markdownit.MarkdownIt | null = null;

    static initializeMarkdown(): void {
        if (!MarkdownUtils.md) {
            MarkdownUtils.md = (window as any).markdownit({
                html: true, // Enable inline HTML
            })
                .enable('code')           // Enable inline and block code formatting
                .enable('fence')          // Enable fenced code blocks
                .enable('link')           // Enable hyperlink parsing
                .enable('html_inline')    // Enable inline HTML like <sub>, <sup>, <ins>
                .enable('html_block')     // Enable block-level HTML
                .enable('emphasis')       // Enable **emphasis** and __emphasis__
                .enable('strikethrough')  // Enable ~~strikethrough~~
                .enable('blockquote');    // Enable block quotes (e.g., > This is a quote)

            // Customize rendering for links to add target="_blank"
            const defaultLinkRenderer =
                MarkdownUtils.md!.renderer.rules.link_open ||
                ((
                    // TODO: swap over the any type hints to the real ones after
                    // markdownit is installed using npm.
                    tokens: any[],
                    // tokens: markdownit.Token[],
                    idx: number,
                    options: any,
                    // options: markdownit.Options,
                    env: any,
                    self: any,
                    // self: markdownit.Renderer,
                ): string => {
                    return self.renderToken(tokens, idx, options);
                });


            MarkdownUtils.md.renderer.rules.link_open = (
                // TODO: swap over the any type hints to the real ones after
                // markdownit is installed using npm.
                tokens: any[],
                // tokens: markdownit.Token[],
                idx: number,
                options: any,
                // options: markdownit.Options,
                env: any,
                self: any,
                // self: markdownit.Renderer,
            ) => {
                const token = tokens[idx];
                // Add target="_blank" to links
                const hrefIndex = token.attrIndex('href');
                if (hrefIndex >= 0) {
                    token.attrSet('target', '_blank');
                }
                return defaultLinkRenderer(tokens, idx, options, env, self);
            };
        }
    }

    static render(markdown: string): string {
        MarkdownUtils.initializeMarkdown();
        return MarkdownUtils.md!.render(markdown.trim());
    }

    static logTest(): void {
        const markdownString = `
        Test comment - 111-222-3333

# H1
## H2
### H3
#### H4
##### H5
###### H6

regular

*italics*
_italics_

**bold**
__bold__

**_bold italics_**

__*bold italics*__

Some \`inline code\` goes here

\`\`\`
|-------
|-------
|-------
|-------
|-------
|-------
\`\`\`

This is some code

\`\`\`dart
class Test {
  double a = 1;

  @override
  void initState() {}
}
\`\`\`

https://google.com

You can [click here](https://google.com) to go to a web page

try that ^

**This is bold text**

_This text is italicized_

~~This was mistaken text~~

**This text is _extremely_ important**

***All this text is important***

This is a <sub>subscript</sub> text

This is a <sup>superscript</sup> text

This is an <ins>underlined</ins> text

> Quoted text

^ was quoted text
`;
        const renderedHtml = MarkdownUtils.render(markdownString);
        console.log(markdownString);
        console.log(renderedHtml);
    }
}
